import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success-registration',
  templateUrl: './success-registration.component.html',
  styleUrls: ['./success-registration.component.scss']
})
export class SuccessRegistrationComponent implements OnInit {
  registrationData: any;
  clearTimer: any;
  copyFeedback: { [key: string]: boolean } = {};
  cacheBuster = Date.now();

  constructor(private router: Router) { }

  // ngOnInit() {
  //   const nav = this.router.getCurrentNavigation();
  //   console.log(nav);

  //   this.registrationData = history.state.registrationData;
  //   console.log('Registration Data:', this.registrationData);

  //   // Set default confirmed_date if not present
  //   if (!this.registrationData?.confirmed_date) {
  //     this.registrationData.confirmed_date = new Date();
  //   }
  // }

  ngOnInit() {
    this.cacheBuster = Date.now();
    const nav = this.router.getCurrentNavigation();
    console.log(nav);

    // Get data
    this.registrationData = history.state?.registrationData;

    console.log('Registration Data:', this.registrationData);

    // If page opened directly without data
    if (!this.registrationData) {
      console.log("No Registration Data");

      // window.location.href = 'https://aieventzo.com/';
      // return;
    }

    // Default confirmed date
    if (!this.registrationData.confirmed_date) {
      this.registrationData.confirmed_date = new Date();
    }

    // Remove browser history state immediately
    window.history.replaceState({}, document.title);

    // Auto clear after 5 mins
    this.clearTimer = setTimeout(() => {
      this.clearRegistrationData();
    }, 5 * 60 * 1000);
  }

  clearRegistrationData() {

    this.registrationData = null;

    // Optional redirect
    // this.router.navigate(['/']);
  }

  ngOnDestroy() {

    // Cleanup timer
    if (this.clearTimer) {
      clearTimeout(this.clearTimer);
    }

    // Clear data when leaving page
    this.registrationData = null;

    // Remove state
    window.history.replaceState({}, document.title);
  }

  /**
   * Navigate to home page
   */
  goHome() {
    window.location.href = 'https://aieventzo.com/';
  }

  /**
   * Navigate to registration page to register another person
   */
  newRegistration() {
    this.router.navigate(['/Registration/', this.registrationData?.event_id]);
  }
  /**
   * Download the ID card image
   * Uses native browser download or opens in new tab
   */
  downloadCard() {
    if (!this.registrationData?.card_image) {
      console.warn('No card image available for download');
      return;
    }

    const imageUrl = `${this.registrationData.card_image}?v=${this.cacheBuster}`;

    try {
      // Create a temporary anchor element for download
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = `event-pass-${this.registrationData?.mem_id}.png`;

      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Fallback: open in new tab if download fails
      setTimeout(() => {
        if (!link.download) {
          window.open(imageUrl, '_blank');
        }
      }, 100);
    } catch (error) {
      console.error('Error downloading card:', error);
      // Fallback to opening in new tab
      window.open(imageUrl, '_blank');
    }
  }

  /**
   * Share registration details via social media or messaging
   */
  shareCard() {

    const imageUrl = `${this.registrationData?.card_image}?v=${this.cacheBuster}`;
    const shareData = {
      title: `${this.registrationData?.event_name} - Registration Confirmed`,
      text: `I've registered for ${this.registrationData?.event_name}! My Registration ID: #${this.registrationData?.mem_id}`,
      url: imageUrl
    };

    // Check if Web Share API is available
    if (navigator.share) {
      navigator.share(shareData).catch(err => {
        console.log('Share cancelled or error:', err);
        this.fallbackShare(shareData);
      });
    } else {
      // Fallback for browsers that don't support Web Share API
      this.fallbackShare(shareData);
    }
  }

  /**
   * Fallback share method - opens share options dialog
   */
  private fallbackShare(data: any) {
    const text = `${data.text}\n${data.url}`;

    // Copy to clipboard as fallback
    this.copyToClipboard(text);

    // Show confirmation
    this.showNotification('Share details copied to clipboard!');
  }

  /**
   * Copy text to clipboard with visual feedback
   * @param text - Text to copy
   * @param feedbackKey - Optional key for feedback state
   */
  copyToClipboard(text: string, feedbackKey: string = 'default') {
    if (!text) {
      console.warn('No text provided to copy');
      return;
    }

    try {
      // Modern Clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.showCopyFeedback(feedbackKey);
        }).catch(err => {
          console.error('Clipboard API failed:', err);
          this.fallbackCopyToClipboard(text);
        });
      } else {
        // Fallback for older browsers
        this.fallbackCopyToClipboard(text);
      }
    } catch (error) {
      console.error('Error copying to clipboard:', error);
      this.fallbackCopyToClipboard(text);
    }
  }

  /**
   * Fallback method for copying to clipboard
   */
  private fallbackCopyToClipboard(text: string) {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      const result = document.execCommand('copy');
      document.body.removeChild(textarea);

      if (result) {
        this.showNotification('Copied to clipboard!');
      }
    } catch (error) {
      console.error('Fallback copy failed:', error);
      this.showNotification('Failed to copy. Please try again.');
    }
  }

  /**
   * Show visual feedback when copying
   */
  private showCopyFeedback(feedbackKey: string) {
    this.copyFeedback[feedbackKey] = true;
    this.showNotification('Registration ID copied!');

    // Reset feedback after 2 seconds
    setTimeout(() => {
      this.copyFeedback[feedbackKey] = false;
    }, 2000);
  }

  /**
   * Show notification/toast message
   * Can be integrated with your toast service
   */
  private showNotification(message: string) {
    console.log('Notification:', message);
    // TODO: Integrate with your toast/notification service
    // Example: this.toastr.success(message);
  }

  /**
   * Print the registration confirmation
   */
  printConfirmation() {
    window.print();
  }

  /**
   * Open support/help page
   */
  openSupport() {
    window.open('/support', '_blank');
  }
}